var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.1413C5 2.51098 5.51098 2 6.1413 2H17.8587C18.489 2 19 2.51098 19 3.1413V4L21.066 4C22.0319 4 22.95 4.72011 22.9917 5.81048C23.027 6.7313 22.9738 8.28701 22.3528 9.73151C21.7249 11.1922 20.5089 12.5357 18.3479 12.9543C17.3685 15.0552 15.3768 16.5891 13 16.9291V20H14.9979C15.5503 20 15.9982 20.4477 15.9982 21C15.9982 21.5523 15.5503 22 14.9979 22H8.99561C8.44317 22 7.99533 21.5523 7.99533 21C7.99533 20.4477 8.44317 20 8.99561 20H11V16.9291C8.62318 16.5891 6.63152 15.0552 5.65211 12.9543C3.49108 12.5357 2.27514 11.1922 1.64719 9.73151C1.0262 8.28701 0.973046 6.7313 1.0083 5.81048C1.05004 4.72011 1.96814 4 2.93404 4L5 4V3.1413ZM7 10V4H17V10C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10ZM5 6V10C5 10.2214 5.01028 10.4403 5.03038 10.6564C4.25462 10.2641 3.78571 9.64082 3.4852 8.94179C3.057 7.94575 2.98295 6.80074 3.00377 6L5 6ZM18.9696 10.6564C19.7454 10.2641 20.2143 9.64082 20.5148 8.94179C20.943 7.94575 21.017 6.80074 20.9962 6L19 6V10C19 10.2214 18.9897 10.4403 18.9696 10.6564Z",
    fill: "#4F49DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.789f6f59.svg";
export { ForwardRef as ReactComponent };